/**
 * 轨道/元素类型
 */
export enum TrackType {
  // Effect = 'effect', // 特效
  Text = 'text', // 文本
  Sticker = 'sticker', // 贴纸
  Filter = 'filter', // 滤镜
  Video = 'video', // 视频
  Audio = 'audio', // 音效
}

export enum TrackMode {
  // 传统模式
  Tradition = 'tradition',
  // 片段模式
  Fragment = 'fragment',
}
